import * as React from 'react';

function Weightlifting(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M16.125 7.002a1.875 1.875 0 011.837 1.501L18 8.502a2.25 2.25 0 012.246 2.118l.004.132v3a2.251 2.251 0 01-2.288 2.25 1.875 1.875 0 01-3.712-.375v-2.625h-4.5v2.625a1.875 1.875 0 01-3.713.375H6a2.25 2.25 0 01-2.246-2.118l-.004-.132v-.75H3v-1.5h.75v-.75A2.25 2.25 0 016 8.502h.037a1.875 1.875 0 013.713.375v2.625h4.5V8.877a1.875 1.875 0 011.875-1.875zm-8.25 1.5a.375.375 0 00-.375.375v6.75a.375.375 0 00.75 0v-6.75a.375.375 0 00-.375-.375zm8.25 0a.375.375 0 00-.375.375v6.75a.375.375 0 00.75 0v-6.75a.375.375 0 00-.375-.375zm-10.123.307L6 8.877v1.125a.75.75 0 00-.745.662l-.005.088v3a.75.75 0 00.662.745l.088.005v1.149-6.774c0-.023 0-.045.002-.068zM18 10.002v4.5l.088-.005a.75.75 0 00.657-.657l.005-.088v-3a.75.75 0 00-.662-.745L18 10.002zm3 1.5v1.5h-.75v-1.5H21z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Weightlifting;
